<template>
  <BaseDatatable
    :key="componentKey"
    :tableData="dataChanged"
    :model="dataModel"
    :options="options"
    :filterDefault="filters"
    :getFilterOptions="getFilterOptions"
    :actions="actions"
    :pagination="pagination"
    :scrollHeight="scrollHeight"
    :globalFilterFields="globalFilterFields"
    :isFilter="isFilter"
    :isCheckBox="isCheckBox"
    :labelHeaderAction="labelHeaderAction"
    :headerCheckBox="headerCheckBox"
    :countCheckBox="countCheckBox"
    :isExpand="isExpand"
    :subModel="subModel"
    :subtableTitle="subtableTitle"
    :subParams="subParams"
    :subOrderBy="subOrderBy"
    :dateType="dateType"
    :columnsDisplays="columnsDisplays"
    :totalRecords="totalRecords"
    :first="first"
    :classDatatable="classDatatable"
    :arrCheckBoxHidden="arrCheckBoxHidden"
    :multiSortMeta="multiSortMeta"
    :column_footer="column_footer"
    :map_custom_filter="map_custom_filter"
    v-on:action-click="onActionClicked"
    @row-select="onRowSelected"
    @row-select-all="onRowSelectedAll"
    @clear-click="clearClick"
    v-on:callback="callback"
    v-on:info_overview="info_overview"
    @filter_date="onFilterDate"
    @filter="filterData"
    @page-click="pageClick"
    @filterExport="filterExport"
  ></BaseDatatable>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
export default {
  components: {
    BaseDatatable
  },
  props: {
    actions: Object,
    filterDefault: Object,
    dateTypeDateFilterDefault: {
      type: Number,
      default: null
    },
    scrollHeight: {
      type: String,
      default: ''
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    listData: Array,
    model: Object,
    globalFilterFields: Array,
    isFilter: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Boolean,
      default: true
    },
    labelHeaderAction: {
      type: String,
      default: 'Thao tác'
    },
    isCheckBox: {
      type: Boolean,
      default: false
    },
    isExpand: {
      type: Boolean,
      default: false
    },
    headerCheckBox: {
      type: String,
      default: ''
    },
    subModel: {
      type: Object,
      default: null
    },
    subtableTitle: {
      type: String,
      default: ''
    },
    subParams: {
      type: Array,
      default: null
    },
    columnsDisplays: {
      type: Array,
      default: null
    },
    totalRecords: Number,
    first: {
      type: Number,
      default: 0
    },
    subOrderBy: {
      type: String,
      default: ''
    },
    classDatatable: {
      type: String,
      default: ''
    },
    countCheckBox: {
      type: Boolean,
      default: false
    },
    arrCheckBoxHidden: {
      type: Array,
      default: null
    },
    multiSortMeta: {
      type: Array,
      default: null
    },
    column_footer: {
      type: Array,
      default: null
    },
    map_custom_filter: {
      type: Array,
      default: null
    },
  },
  data() {
    return {
      dateType: 0,
      filters: {},
      filterOptions: {},
      options: [],
      modelName: '',
      dataModel: null,
      componentKey: 0,
      dataChanged: this.listData,
      paginationRows: 10
    }
  },
  async created () {

    if (this.filterDefault !== undefined && this.filterDefault !== null) {
      this.filters = this.filterDefault;
      if (!this.$myConstants.isEmpty(this.dateTypeDateFilterDefault)){
        this.dateType = this.dateTypeDateFilterDefault;
      }
    }


    this.modelName = this.model.name;
    this.dataModel = this.model;
    await this.callbackOptions();
  },
  methods: {
    callback(col, item) {
      this.$emit('callback', col, item);
    },
    info_overview(total_overview) {
      this.$emit('info_overview', total_overview);
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = [];
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models) {
          result = this.options[name];
        }
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    async onActionClicked(payload) {
      this.$emit("action-click", payload);
    },
    onRowSelected(data) {
      this.$emit('row-select', data);
    },
    onRowSelectedAll(data) {
      this.$emit('row-select-all', data);
    },
    clearClick() {
      this.filters = {};
      this.componentKey++;
    },
    onFilterDate(payload) {
      console.log("this.filtersthis.filters:",payload)
      if (payload.col.filter.type == 'Date') this.dateType = 1;
      else if (payload.col.filter.type == 'DateRange') this.dateType = 2;
      else this.dateType = 0;
      if (payload.type != undefined && payload.type != '' && (payload.type == 'from' || payload.type == 'to')) {
        if (this.filters[payload.col.key] == undefined ) this.filters[payload.col.key] = {};
        if (payload.data != undefined) {
          this.filters[payload.col.key][payload.type] = payload.data;
          console.log("555555:",this.filters)
          if (this.filters[payload.col.key] != null && this.filters[payload.col.key]['from'] != null && this.filters[payload.col.key]['to'] != null) {
            var date1 = new Date(moment(this.filters[payload.col.key]['from']).format('YYYY-MM-DD'));
            var date2 = new Date(moment(this.filters[payload.col.key]['to']).format('YYYY-MM-DD'));
            if (Number(date1) > Number(date2)) {
              var dateTemp = this.filters[payload.col.key]['from'];
              this.filters[payload.col.key]['from'] = this.filters[payload.col.key]['to'];
              this.filters[payload.col.key]['to'] = dateTemp;

            }     
          }
        }
        else delete this.filters[payload.col.key][payload.type];
      } else {
        this.filters[payload.col.key] = payload.data;
      }
      this.componentKey = Math.random() * 320;
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields();
      if (fields.length > 0) {
        for (let index = 0; index < fields.length; index++) {
          var attributes = [];
          const element = fields[index];
          if (element.models !== undefined) {
            var optionsData = [];
            attributes.push(element.models.key.key);
            attributes.push(element.models.display_key);
            var select = attributes.join(',');
            var variables = {};
            if (element.params !== undefined  && element.params.select !== undefined) select = element.params.select;
            if (element.params !== undefined  && element.params.variables !== undefined) variables = {where_key : element.params.variables };
            var data = await DataServices.getList(element.models.name, {"variables": JSON.stringify(variables), "fields": select});
            if (data) {
              var result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]], item: ele})
                }
              }
            }
            this.options[element.key] = optionsData;
          }
        }
        this.componentKey = Math.random() * 120;
      }
    },
    filterData(payload) {
      this.$emit('filter', payload);
    },
    pageClick(payload) {
       this.$emit('page-click', payload);
    },
    filterExport(payload) {
       this.$emit('filterExport', payload);
    },
  }
}
</script>
<style lang="scss">
.p-datepicker { width: 300px !important; padding: 0px; padding-top: 5px;
  .p-datepicker-header{padding: 5px !important;}
  td { padding: 0px !important;
    a {padding: 0px !important;}
    span {padding: 0px !important; width: 30px !important; height: 30px !important;}
  }
  .p-datepicker-buttonbar{padding: 5px;}
}

.p-calendar {
  &.date-custom{display: flex; min-width: 250px;
    .p-inputtext{width: auto; flex: inherit;}
    &:last-child{margin-top: 10px;}
  }
}

.label-header-action{display: none;}
.button-clear{cursor: pointer; color: #169BD5;}
.pi-sort-amount-up-alt:before{content: "\e99d";}
.pi-sort-amount-down:before{content: "\e999";}
.p-paginator{
  .p-dropdown{border:1px solid #ccc;}
}
.tex-button, .tex-button:hover{border: none !important; background: none !important; color: #005b9f !important;}
</style>